// @flow
import * as React from 'react';
import {useLocation} from 'docs/data';
import {useStripeClui} from '../helpers/react/provider';
import {Executable} from './_executable';
import {FEEDBACK_PAGE_URL} from '../components/FeedbackAction/FeedbackAction';

export const GoToFeedbackPage = () => {
  const {close} = useStripeClui();
  const {pushLocation} = useLocation();

  React.useEffect(() => {
    close();
    pushLocation(FEEDBACK_PAGE_URL);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return null;
};
export class feedback extends Executable {
  commandName(): string {
    return 'feedback';
  }

  help(): React.Node {
    this.setAllowInput(true);
    return 'please tell us about your experience with Stripe Shell';
  }

  run(): React.Node {
    this.setAllowInput(true);
    return <GoToFeedbackPage />;
  }
}
